module.exports = function () {
  this.app.$on('addCard', payload => {
    console.log('addcard', payload)
    payload.token = payload.token || this.session.token
    this.sdk.post('/me/cards',
      payload,
      response => {
        if (response.success) {
          this.app.$emit('addCardSuccess', response)
        } else {
          this.app.$emit('addCardFail', response)
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/events/add-card.js